// Autogenerated file
export const vehicleOwnershipTypesEnum = {
    Own: "Own",
    SpousesJointProperty: "SpousesJointProperty",
    Rent: "Rent",
    Leasing: "Leasing",
    FreeUse: "FreeUse",
};
export const vehicleOwnershipTypes = [
    { label: "Собственность", value: "Own" },
    { label: "Совместная собственность супругов", value: "SpousesJointProperty" },
    { label: "Аренда", value: "Rent" },
    { label: "Лизинг", value: "Leasing" },
    { label: "Безвозмездное пользование", value: "FreeUse" },
];
